<template>
  <el-popover 
    ref="popover" 
    :placement="placement" 
    :width="width" 
    :reference="referenceEle"
    :popper-class="popperClass"
    @show="$emit('show', payload)"
    @hide="$emit('hide', payload)"
  >
    <div ref="content">
      <slot :payload="payload"></slot>
    </div>
  </el-popover>
</template>

<script>
export default {
  name: 'DynamicPopover',
  props: {
    width: [String, Number],
    placement: String,
    popperClass: [Array, String],
  },
  data () {
    return {
      referenceEle: null,
      payload: {},
    }
  },
  methods: {
    show(el, payload) {
      if (this.$refs.popover.showPopper) {
        this.$refs.popover.handleBlur() 
        window.setTimeout(() => {
          this._showPop(el, payload)
        }, 300)
      } else {
        this._showPop(el, payload)
      }
    },
    _showPop(el, payload) {
      this.referenceEle = el
      this.payload = payload || {}
      this.$refs.popover.referenceElm = this.referenceEle
      this.$refs.popover.doShow()
    },
    close() {
      this.$refs.popover.doClose()
    },
    refeshPopsition() {
      this.$refs.popover.updatePopper()
    },
  }
}
</script>

<style>

</style>